module.exports = __webpack_public_path__ + "img/greenReadingScience3.5f98d07a.png";